export const Projects = [
  {
    title: 'Meu Portfólio',
    description: 'Potfólio desenvolvido ReactJS, utilizando React Icons e React Router Dom. Primeiro projeto em React completo.',
    repository: 'https://github.com/matheus-germano/react-portfolio',
    link: 'https://matheus-germano.vercel.app/'
  },
  {
    title: 'Games Ecommerce (ainda em desenvolvimento)',
    description: 'Uma loja virtual com foco no público gamer, vendendo jogos, consoles e periféricos.',
    repository: 'https://github.com/matheus-germano/games-ecommerce',
    link: 'https://games-ecommerce.vercel.app/'
  },
  {
    title: 'Find Jobs',
    description: 'Uma plataforma para freelancers encontrarem projetos. Projeto desenvolvido para a conclusão de curso do curso técnico em informática.',
    repository: 'https://github.com/caiocichetti/tcc-findjobs-web',
    link: ''
  },
  {
    title: 'Fuel Calculator',
    description: 'Um simples projeto que calcula quantos litros você irá abastecer de acordo com os valores informados.',
    repository: 'https://github.com/matheus-germano/fuel-calculator',
    link: 'https://fuelcalculator.vercel.app/'
  },
  {
    title: 'Antigo Portfólio (desatualizado)',
    description: 'Potfólio desenvolvido em html, css e bootstrap4. Hoje em dia não está sendo utilizado.',
    repository: 'https://github.com/matheus-germano/portfolio',
    link: 'https://matheus-germano.github.io/portfolio/'
  },
]
